export default "__VITE_ASSET__DyBkEPE3__"